import moment from 'moment'
import {
    changeFieldDefault, changeFieldDisabled,
    setFieldEndDate,
    setFieldStartDate, setFieldVisibility, setFormButtons,
} from "../../../../apps/KpModule/actions";
import {basicContext} from "../../../utils/contextUtils";
import Errors from "../../../utils/Errors";
import async from "async";
import {returnButton, saveButton, sendButton} from "../utils/demandUtils";
import {getDataListList} from "../../../../apps/KpModule/selectors";

export const entity = {
    name: 'MeetingsPlanning',
    fields: [
        {path: 'code', unique: true, uniqueWith: ['fiscalYear']},
        {path: 'fiscalYear', type: 'FiscalYear'},
        {path: 'meetingsPlanningRange', type: 'dateRange'},
        {path: 'budgetReportingPeriod', type: 'dateRange'},
        {path: 'revisedReportingPeriod', type: 'dateRange'},
        //month
        //startDay
        //endDay
    ],
    filters: [
        {
            name: "onlyOngoing",
            isDefault: false,
            query: function() {
                const currentDay = moment(moment().format('YYYY-MM-DD')).toDate()
                return {startDay: {$lte: currentDay}, endDay: {$gte: currentDay}}
            }
        },
    ],
    meetingsPlanningRangeIsRequired: function(newObject, oldObject, context, callback) {
        const hasMissingMeetingsPlanningRange = newObject.meetingsPlanningRange.some(date => !date)
        if (hasMissingMeetingsPlanningRange) return callback(new Errors.ValidationError(context.tc("meetingsPlanningRangeIsRequired")))

        callback();
    },
    budgetReportingPeriodIsRequired: function(newObject, oldObject, context, callback) {
        const hasMissingBudgetReportingPeriod = newObject.budgetReportingPeriod.some(date => !date)
        if (hasMissingBudgetReportingPeriod) return callback(new Errors.ValidationError(context.tc("budgetReportingPeriodIsRequired")))

        callback();
    },
    revisedReportingPeriodIsRequired: function(newObject, oldObject, context, callback) {
        const hasMissingRevisedReportingPeriod = newObject.revisedReportingPeriod.some(date => !date)
        if (hasMissingRevisedReportingPeriod) return callback(new Errors.ValidationError(context.tc("revisedReportingPeriodIsRequired")))

        callback();
    },
    isMeetingsPlanningStartBeforeEnd: function(newObject, oldObject, context, callback) {
        const isStartBeforeEnd = moment(newObject.meetingsPlanningRange[0]).isBefore(newObject.meetingsPlanningRange[1])
        if (!isStartBeforeEnd) return callback(new Errors.ValidationError(context.tc("meetingsPlanningRangeStartBeforeEnd")))

        callback();
    },
    isBudgetReportingPeriodStartBeforeEnd: function(newObject, oldObject, context, callback) {
        const isStartBeforeEnd = moment(newObject.budgetReportingPeriod[0]).isBefore(newObject.budgetReportingPeriod[1])
        if (!isStartBeforeEnd) return callback(new Errors.ValidationError(context.tc("budgetReportingPeriodStartBeforeEnd")))

        callback();
    },
    isRevisedReportingPeriodStartBeforeEnd: function(newObject, oldObject, context, callback) {
        const isStartBeforeEnd = moment(newObject.revisedReportingPeriod[0]).isBefore(newObject.revisedReportingPeriod[1])
        if (!isStartBeforeEnd) return callback(new Errors.ValidationError(context.tc("revisedReportingPeriodStartBeforeEnd")))

        callback();
    },
    revisedReportingPeriodIsIncludedInMeetingsPlanningRange: function(newObject, oldObject, context, callback) {
        const revisedReportingPeriodIsIncludedInMeetingsPlanningRange  = moment(newObject.revisedReportingPeriod[0]).isBetween(newObject.meetingsPlanningRange[0], newObject.meetingsPlanningRange[1], 'day', '[]')
        if (!revisedReportingPeriodIsIncludedInMeetingsPlanningRange){
            return callback(new Errors.ValidationError(context.tc("revisedReportingPeriodIsIncludedInMeetingsPlanningRangeError")))
        }
        callback();
    },
    checkMeetingPlanningForDiscontinuity: function ( newObject, oldObject, context, callback) {
        async.parallel([
            callback => global.app.SE.MeetingsPlanning.find({
                ...basicContext(context),
                fieldPath: [],
                query: {_id: {$ne: new global.ObjectID(newObject.id)}}
            }, (e, objects) => {
                callback(e, objects.length === 0)
            }),
            callback => global.app.SE.MeetingsPlanning.find({
                ...basicContext(context),
                fieldPath: [],
                query: {
                    _id: {$ne: new global.ObjectID(newObject.id)},
                    "meetingsPlanningRange.1": {$eq: moment(newObject.meetingsPlanningRange[0]).subtract(1, 'days').toDate()}
                }
            }, (e, objects) => {
                callback(e, !!objects.length && objects.length === 1)
            })
        ],(error, results) => {
            if (error) return callback(error)
            const [isFirstMeetingPlanning, noDiscontinuityProblem] = results

            if (!isFirstMeetingPlanning && !noDiscontinuityProblem){
                return callback(new Errors.ValidationError(context.tc("meetingPlanningRangesDiscontinuityError")))
            }

            return callback()
        })
    },
    checkForOverlapping: function (newObject, oldObject, context, callback) {
        async.parallel([
                callback => global.app.SE.MeetingsPlanning.find({
                        ...basicContext(context),
                        fieldPath: [],
                        query: {
                            _id: {$ne: new global.ObjectID(newObject.id)},
                            $or: [{"meetingsPlanningRange.0": {$lte: newObject.meetingsPlanningRange[1]}, "meetingsPlanningRange.1": {$gte: newObject.meetingsPlanningRange[0]}}]
                        }
                    }, callback),
                callback => global.app.SE.MeetingsPlanning.find({
                    ...basicContext(context),
                    fieldPath: [],
                    query: {
                        _id: {$ne: new global.ObjectID(newObject.id)},
                        $or: [{"budgetReportingPeriod.0": {$lte: newObject.budgetReportingPeriod[1]}, "budgetReportingPeriod.1": {$gte: newObject.budgetReportingPeriod[0]}}]
                    }
                }, callback),
                callback => global.app.SE.MeetingsPlanning.find({
                    ...basicContext(context),
                    fieldPath: [],
                    query: {
                        _id: {$ne: new global.ObjectID(newObject.id)},
                        $or: [{"revisedReportingPeriod.0": {$lte: newObject.revisedReportingPeriod[1]}, "revisedReportingPeriod.1": {$gte: newObject.revisedReportingPeriod[0]}}]
                    }
                }, callback),
            ],(error, results) => {
            if (error) return callback(error)
            const [meetingsPlanningRanges, budgetReportingPeriod, revisedReportingPeriod] = results

            if (!!meetingsPlanningRanges.length){
                return callback(new Errors.ValidationError(context.tc("meetingPlanningRangesOverlappingError")))
            }
            if (!!budgetReportingPeriod.length){
                return callback(new Errors.ValidationError(context.tc("budgetReportingPeriodOverlappingError")))
            }
            if (!!revisedReportingPeriod.length){
                return callback(new Errors.ValidationError(context.tc("revisedReportingPeriodOverlappingError")))
            }
            return callback()
        })
    },
    validateSave: function(newObject, oldObject, context, callback) {
        async.series([
            //callback => this.uniqueProcess( newObject.id, newObject.meetingsPlanningRange, newObject.budgetReportingPeriod, newObject.revisedReportingPeriod, context, callback),
            callback => this.meetingsPlanningRangeIsRequired(newObject, oldObject, context, callback),
            callback => this.budgetReportingPeriodIsRequired(newObject, oldObject, context, callback),
            callback => this.revisedReportingPeriodIsRequired(newObject, oldObject, context, callback),
            callback => this.isMeetingsPlanningStartBeforeEnd(newObject, oldObject, context, callback),
            callback => this.isBudgetReportingPeriodStartBeforeEnd(newObject, oldObject, context, callback),
            callback => this.isRevisedReportingPeriodStartBeforeEnd(newObject, oldObject, context, callback),
            callback => this.revisedReportingPeriodIsIncludedInMeetingsPlanningRange(newObject, oldObject, context, callback),
            callback => this.checkForOverlapping(newObject, oldObject, context, callback),
            callback => this.checkMeetingPlanningForDiscontinuity(newObject, oldObject, context, callback)
        ], callback)
    },
}
export const module_ = {
    object: 'MeetingsPlanning',
    category: {
        path: 'paramétrage',
        icon: 'settings'
    },
    tKey: 'echéance',
    viewMap: {
        dt: [
            {path: 'code', width: 100},
            {path: 'fiscalYear', tKey: 'exercice', display: 'code', width: 100},
            'meetingsPlanningRange',
            {path: 'budgetReportingPeriod', width: 300},
            'revisedReportingPeriod',
        ],
        form: {
            fields : [
                {path: 'code', required: true},
                {
                    path: 'fiscalYear',
                    tKey: 'exercice',
                    display: 'code',
                    editable: false,
                    filters:['nonClosed'],
                    fieldPath: ['id', 'fiscalYearRange', 'code'],
                    subscriptions: {
                        onChange: (newValue, oldValue, {module, store}) => {
                            const meetingsPlanningRangeField = module.viewMap.form.fields.find( field => field.path === 'meetingsPlanningRange')
                            const objectMode = store.getState().ui.objectMode

                            if(objectMode === 'newObject') {
                                if (newValue) {
                                    meetingsPlanningRangeField.setValue([newValue.fiscalYearRange[0], newValue.fiscalYearRange[0]])
                                }
                                else{
                                    meetingsPlanningRangeField.setValue(null)
                                }
                            }
                        }
                    }
                },
                {
                    path: 'meetingsPlanningRange',
                    tKey: 'Période échéance',
                    required: true,
                    default: null,
                },
                {
                    path: 'budgetReportingPeriod',
                    tKey: 'Renseignement Ré-estimé Budget',
                    default: null,
                    required: true
                },
                {
                    path: 'revisedReportingPeriod',
                    tKey: 'Renseignement Révisé',
                    default: null,
                    required: true
                },
            ],
            onOpen: ({ module, state, store }) => {
                const fiscalYearField = module.viewMap.form.fields.find(field => field.path === 'fiscalYear')
                const objectMode = state.ui.objectMode
                store.dispatch(changeFieldDisabled(fiscalYearField.id, objectMode !== 'newObject'))
            },
        }
    }
}